import React, { useCallback, useEffect, useState } from 'react';
import { useMytaverse } from '../../../../../providers/MytaverseProvider';
import ParticipantsService from '../../../../../services/ParticipantsService';
import PolicyModalView from './PolicyModalView';
import { IUser } from '../../../../../interfaces/user';
import { env } from '../../../../../env';

const PDF_URL = env.REACT_APP_TERMS_PDF_URL;

const PolicyModal = () => {
  const { user, setUser, logoutUser } = useMytaverse();
  const blackListDomains = [
    'zhacity.mytaverse.com',
    'metrotopia.mytaverse.com',
  ];

  const [open, setOpen] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    const isNotInBlackList = blackListDomains.some(
      (domain) => domain === window.location.hostname,
    );

    if (user && !user.isTermsAccepted && !isNotInBlackList) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [user]);

  const handleClose = useCallback(() => {
    logoutUser();
  }, [logoutUser]);

  const handleScroll = useCallback((event: React.UIEvent<HTMLDivElement>) => {
    const target = event.target as HTMLDivElement;

    const buffer = 30;

    if (
      target.scrollHeight - target.scrollTop <=
      target.clientHeight + buffer
    ) {
      setIsEnd(true);
    }
  }, []);

  const handleAccept = useCallback(async () => {
    if (!isEnd || !user) {
      return;
    }

    try {
      setIsProcessing(true);
      await ParticipantsService.updateCurrentParticipantProfileTC({
        isTermsAccepted: true,
      });

      setUser((prevState: IUser) => ({
        ...prevState,
        isTermsAccepted: true,
      }));

      setOpen(false);
    } catch (e) {
      console.error('Error updating profile:', e);
    } finally {
      setIsProcessing(false);
    }
  }, [user, isEnd, setOpen]);

  if (!open || !PDF_URL) {
    return null;
  }

  return (
    <PolicyModalView
      file={PDF_URL}
      open={open}
      isRead={isEnd}
      disabled={!isEnd || isProcessing}
      handleScroll={handleScroll}
      onClose={handleClose}
      onClick={handleAccept}
    />
  );
};

export default PolicyModal;
